import { isMockMode, post, simulateDelay } from "../api";

export const createOffering = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Offerings/Create`, data, {
		successMessage: "Offering successfully created",
	});
};
